/* Patriot Bikes V2.0 — FAQ accordion. Progressive enhancement:
   without JS every answer is visible (details/summary-like fallback via .is-open). */
class PBFaq extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.pb-faq__item'));
    this.items.forEach((item) => {
      const btn = item.querySelector('.pb-faq__q');
      if (btn) btn.addEventListener('click', () => this.toggle(item, btn));
    });
  }
  toggle(item, btn) {
    const open = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', String(open));
  }
}
if (!customElements.get('pb-faq')) {
  customElements.define('pb-faq', PBFaq);
}
